import {
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICE_FAILURE,
  FETCH_ALL_INVOICE_REQUEST,
  FETCH_ALL_INVOICE_SUCCESS,
  FETCH_ALL_INVOICE_FAILURE,
  RESET_INVOICE_DETAILS,
  FETCH_CUSTOMER_ALL_INVOICE_REQUEST,
  FETCH_VENDOR_ALL_INVOICE_REQUEST,
  FETCH_CUSTOMER_ALL_INVOICE_SUCCESS,
  FETCH_VENDOR_ALL_INVOICE_SUCCESS,
  FETCH_CUSTOMER_ALL_INVOICE_FAILURE,
  FETCH_VENDOR_ALL_INVOICE_FAILURE,
} from '../Invoice/InvoiceType';

const initialState = {
  invoice: null,
  invoices: [],
  loading: false,
  success: false,
  error: null,
  customerInvoice: {
    data: null,
    loading: false,
    error: false,
    success: false,
  },
  vendorInvoice: {
    data: null,
    loading: false,
    error: false,
    success: false,
  },
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVOICE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case FETCH_ALL_INVOICE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case FETCH_CUSTOMER_ALL_INVOICE_REQUEST:
      return {
        ...state,
        customerInvoice: {
          data: null,
          loading: false,
          error: false,
          success: false,
        },
      };
    case FETCH_VENDOR_ALL_INVOICE_REQUEST:
      return {
        ...state,
        vendorInvoice: {
          data: null,
          loading: false,
          error: false,
          success: false,
        },
      };

    case FETCH_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        invoice: action.payload,
        success: true,
      };

    case FETCH_ALL_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        invoices: action.payload,
        success: true,
      };
    case FETCH_CUSTOMER_ALL_INVOICE_SUCCESS:
      return {
        ...state,
        customerInvoice: {
          data: action.payload,
          loading: false,
          error: false,
          success: true,
        },
      };
    case FETCH_VENDOR_ALL_INVOICE_SUCCESS:
      return {
        ...state,
        vendorInvoice: {
          data: action.payload,
          loading: false,
          error: false,
          success: true,
        },
      };
    case FETCH_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case FETCH_ALL_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case FETCH_CUSTOMER_ALL_INVOICE_FAILURE:
      return {
        ...state,
        customerInvoice: {
          data: action.payload,
          loading: false,
          error: true,
          success: false,
        },
      };
    case FETCH_VENDOR_ALL_INVOICE_FAILURE:
      return {
        ...state,
        vendorInvoice: {
          data: action.payload,
          loading: false,
          error: true,
          success: false,
        },
      };
    case RESET_INVOICE_DETAILS:
      return {
        ...state,
        invoice: null,
        invoices: [],
        loading: false,
        error: null,
        customerInvoice: {
          data: null,
          loading: false,
          error: false,
          success: false,
        },
        vendorInvoice: {
          data: null,
          loading: false,
          error: false,
          success: false,
        },
      };

    default:
      return state;
  }
};

export default invoiceReducer;
